export default {"src":"https://fishbrain.com/_next/static/media/tennessee.a1f04454.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};